export enum AccessLogTargetType {
    Sample = 0,
    IhLabResult = 1,
    EmployeeCustomEntity = 2,
    Other = 3
}
